/**
 * tk-gift — dárek zdarma k nákupu nad práh.
 *
 * Stav počítá Liquid (`snippets/tk-gift-bar.liquid`) při každém re-renderu cart
 * sekce; tenhle modul jen provádí akce, které Liquid udělat nemůže:
 *
 *   1. AUTO-ADD    — vznikl nárok a dárek v košíku není → přidat.
 *   2. AUTO-REMOVE — košík klesl pod práh, dárek se musí odebrat (jinak by ho
 *                    zákazník zaplatil... resp. dostal zdarma bez nároku).
 *   3. ODMÍTNUTÍ   — odebere dárek a zapíše cart attribute `_darek_odmitnut`,
 *                    aby se sám nevrátil.
 *
 * 🔴 AUTO-ADD ZPĚT (2026-09-04) — a s ním PRYČ OKNO „Chci / Nechci dárek".
 * Historie: auto-add se 2026-08-29 vyhodil na výtku „tabulka vyskočí, dám
 * refresh, nic neodkliknu a produkt se jakoby automaticky přidá? to nechceme."
 * Vadilo na tom ale to, že okno POLOŽILO OTÁZKU a neodpověď si vyložilo jako
 * ano. Bez okna ta námitka mizí: dárek je prostě součást košíku, vypsaný jako
 * vlastní označený řádek s tlačítkem „Nechci dárek" hned u sebe
 * (`snippets/cart-products.liquid`). Nikdo se na nic neptá, takže není co
 * odpovídat za zákazníka. Zadání od uživatele + dvou kolegů 2026-09-04:
 * „defaultně přidáno v košíku, mezi položkami jako označený řádek, a u toho
 * zvýrazněné tlačítko nechci dárek."
 *
 * 🔴 OD 2026-09-09 JE DÁREK SKUTEČNÝ PRODEJNÍ PRODUKT, ne skrytý duplikát.
 * Dárkový řádek se proto pozná podle line item property `_darek: ano` (plus
 * dárková varianta) — tentýž produkt si zákazník může normálně koupit a ten
 * řádek property nemá, takže zůstává placený. Shopify řádky s různými
 * properties neslučuje. Důsledky tady:
 *   - auto-add jde přes `/cart/add.js` (jediný endpoint, který properties
 *     umí), a protože vrací jen přidanou položku, hned za ním jde prázdný
 *     `/cart/update.js` se `sections`, ze kterého se morphuje celý košík
 *     a bere `item_count` (bez něj by badge v hlavičce skočil na 0);
 *   - odebrání/odmítnutí jde VŽDY přes klíč řádku (`data-line-key`), nikdy
 *     přes `updates: { variantId: 0 }` — to by smazalo i placený nákup
 *     téhož produktu.
 * Detekci řádku dělá Liquid (`tk-gift-bar.liquid`, `cart-products.liquid`),
 * slevu na nulu Shopify Function `gift-discount` podle téže property.
 *
 * 🔴 POJISTKY PROTI SMYČCE ADD ↔ REMOVE (jediné, co na auto-addu doopravdy
 * bolí): `addAttempts` (max 3 pokusy na jeden nárok), `ADD_COOLDOWN` (nejvýš
 * jeden pokus za 4 s) a `chargedGiftSeen` — když se dárek při TRVAJÍCÍM nároku
 * vrátil ÚČTOVANÝ (slevový kód bez `combinesWith.productDiscounts`), auto-add
 * se do konce nároku vypne. Bez toho by se přidával a odebíral donekonečna.
 *
 * 🔴🔴 KAŽDÁ Z NICH JE LATCH, A LATCH SE MUSÍ MÍT KDE VYNULOVAT. Všechny je
 * proto nuluje jediná `resetAddGuards()` a volá se ze tří míst: zánik nároku,
 * dárek v pořádku v košíku, a PRÁZDNÝ KOŠÍK (tam lišta neexistuje, takže
 * `#reconcile` vůbec neběží — přesně tímhle se to 2026-09-04 rozbilo, podrobně
 * u `scheduleReconcile`). Když přidáváš další pojistku, přidej ji tam taky.
 *
 * 🔴 ⚠️ POZOR — DŘÍVE TU BYLO NAPSÁNO, ŽE SE ELEMENT PO KAŽDÉM MORPHU VYTVOŘÍ
 * ZNOVU. NENÍ TO PRAVDA. `assets/morph.js` element `<tk-gift>` PATCHUJE NA MÍSTĚ
 * (přepíše mu jen atributy), takže `connectedCallback` proběhne JEN při načtení
 * stránky. Celý smír stavu tím po změně košíku bez reloadu NEPROBĚHL a v košíku
 * zůstal dárek, který si Shopify po propadnutí pod práh naúčtoval plnou cenou
 * (ověřeno Playwrightem 2026-08-29: košík 1113 → 338 Kč, dárek dál v košíku
 * za 179 Kč i po 12 s).
 *
 * Proto se smír pouští DVĚMA cestami: `connectedCallback` (první render) a
 * modulový listener na `CartUpdateEvent` (každá další změna košíku). Listener je
 * odložený, protože v době eventu ještě neproběhl morph a atributy na elementu
 * jsou STARÉ — číst se musí až po překreslení.
 *
 * Flag `busy` je na úrovni MODULU, ne instance — instancí `<tk-gift>` je na
 * stránce víc (lišta na /cart + lišta draweru v hlavičce) a nesmí si requesty
 * lézt do zelí.
 */
import { CartUpdateEvent } from '@theme/events';

const ADD_URL = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
const CHANGE_URL = (window.Theme && Theme.routes && Theme.routes.cart_change_url) || '/cart/change.js';
const UPDATE_URL = (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update.js';

const DECLINED_ATTR = '_darek_odmitnut';

/**
 * Line item property, která dělá z řádku dárek. Musí sedět s Liquid detekcí
 * (`tk-gift-bar.liquid`, `cart-products.liquid`) i s input query funkce
 * `gift-discount` (`attribute(key: "_darek")`).
 */
const GIFT_PROP = '_darek';
const GIFT_PROP_VALUE = 'ano';

/** @type {boolean} probíhá požadavek — brání souběhu i smyčce přes morph */
let busy = false;

/**
 * Klíče řádků, které už jsme zkusili odebrat. Bez tohohle by se při zaseklém
 * morphu (element drží STARÁ data) posílalo `change.js` na týž řádek pořád
 * dokola.
 * @type {Set<string>}
 */
const removedKeys = new Set();

/**
 * Nejkratší rozestup dvou pokusů o přidání dárku. Brání tomu, aby dva průchody
 * smíru (`RECONCILE_PASSES`) poslaly dva `update.js` za sebou.
 */
const ADD_COOLDOWN = 4000;

/** @type {number} kdy naposledy odešel pokus o přidání dárku */
let lastAddAt = 0;

/**
 * Kolikrát se v rámci JEDNOHO nároku zkusil dárek přidat, aniž by v košíku
 * skončil. Po třetím pokusu se to vzdá — nemá smysl bušit do košíku, když to
 * Shopify z nějakého důvodu (vyprodáno, limit) odmítá. Nuluje se, jakmile nárok
 * zanikne (viz `#reconcile`).
 * @type {number}
 */
let addAttempts = 0;

/**
 * 🔴 Dárek se aspoň jednou vrátil ÚČTOVANÝ (`data-not-free`). Nastane, když je
 * v košíku slevový kód bez `combinesWith.productDiscounts` — Shopify pak
 * automatickou slevu na dárek neuplatní. Smír takový dárek odebere, jenže bez
 * tohohle příznaku by ho auto-add hned zase přidal a jelo by to dokola.
 * Vypíná auto-add do konce trvání nároku.
 * @type {boolean}
 */
let chargedGiftSeen = false;

/**
 * Slevové kódy v košíku při poslední kontrole (`data-codes` z Liquidu).
 * Když se sada změní, `chargedGiftSeen` se pouští znovu — zákazník mohl
 * blokující kód právě odebrat a dárek mu zas náleží.
 * @type {string|null}
 */
let lastCodes = null;

/**
 * Do kdy se po odmítnutí nesmí nic auto-přidávat — kryje okno, kdy smír čte
 * ještě nezmorfovaný (starý) stav. Viz `#decline()`.
 * @type {number}
 */
let declineGuardUntil = 0;

/**
 * ms po změně košíku, kdy se čte zmorfovaný stav.
 *
 * ⚠️ DVA PRŮCHODY, ne jeden. Morph je asynchronní a po sérii rychlých změn
 * (zákazník několikrát ťukne na „+") nemusí být do 260 ms hotový — smír pak
 * přečte STARÁ data, usoudí, že není co dělat, a protože žádný další
 * `cart:update` už nepřijde, NIKDY se nezopakuje (zachyceno regresní maticí
 * `scripts/_tkcart-matrix.cjs` 2026-08-29, tehdy na auto-addu; pro
 * auto-remove platí totéž). Druhý průchod je levný, `removedKeys` ho jistí.
 */
const RECONCILE_PASSES = [260, 1400];

/** @type {number} kdy naposledy proběhla oslava — zámek proti dvojímu spuštění */
let lastCelebrationAt = 0;

/** @type {number[]} */
let reconcileTimers = [];

/** Pustí smír na VŠECH lištách, až se dokreslí morph. */
/**
 * 🔴 Vynuluje VŠECHNY pojistky auto-addu. Je to jedna funkce schválně — každá
 * pojistka je latch a stačí, aby jediná zůstala viset z minulého kola, a dárek
 * se přestane přidávat, aniž by na tom bylo cokoli vidět.
 */
function resetAddGuards() {
  addAttempts = 0;
  chargedGiftSeen = false;
  lastAddAt = 0;
}

function scheduleReconcile() {
  reconcileTimers.forEach((t) => window.clearTimeout(t));
  reconcileTimers = RECONCILE_PASSES.map((delay) =>
    window.setTimeout(() => {
      const bars = document.querySelectorAll('tk-gift');

      // 🔴 ŽÁDNÁ LIŠTA = PRÁZDNÝ KOŠÍK (lišta se renderuje jen pro
      // `cart.item_count > 0`). `#reconcile` tedy nemá kde běžet a pojistky by
      // zůstaly viset z minulého kola do konce načtené stránky. Přesně tím se
      // 2026-09-04 rozbil scénář „přidám produkt za 2000 (dárek přijde) →
      // produkt smažu (dárek se mezitím stal účtovaným, `chargedGiftSeen`
      // naskočil, dárek se odebral, košík je prázdný) → přidám znovu": nárok
      // byl, dárek chyběl, ale `chargedGiftSeen` pořád držel auto-add zavřený.
      // Prázdný košík je čistý stůl, takže se maže i zámek po odmítnutí
      // a seznam už odebraných řádků.
      if (bars.length === 0) {
        resetAddGuards();
        declineGuardUntil = 0;
        removedKeys.clear();
        return;
      }

      bars.forEach((el) => {
        if (el instanceof HTMLElement && typeof el.reconcileNow === 'function') el.reconcileNow();
      });
    }, delay)
  );
}

/** @returns {string} čárkou oddělené id cart sekcí k re-renderu */
function cartSections() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((component) => component.dataset.sectionId)
    .filter(Boolean)
    .join(',');
}

/**
 * @param {string} url
 * @param {Record<string, unknown>} body
 * @param {{ sections?: boolean }} [options] `sections: false` = jen zápis, bez
 *   re-renderu cart sekcí (mezikrok, jehož odpověď se nemorphuje)
 * @returns {Promise<any>}
 */
async function post(url, body, options = {}) {
  const withSections = options.sections !== false;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(withSections ? { ...body, sections: cartSections() } : body),
  });
  return response.json();
}

/**
 * Přidá dárkový řádek: dárková varianta s property `_darek: ano`.
 *
 * `/cart/add.js` vrací jen přidanou položku (bez `item_count`, se `sections`
 * sice umí, ale morphovat se má až konečný stav), proto se hned za ním čte
 * celý košík prázdným `/cart/update.js` — ten vrací i `sections`. Chyba addu
 * (`{ status, message }`) se vrací rovnou, ať ji `commit` odfiltruje.
 * @param {string} variantId
 * @param {Record<string, string>} [attributes] cart attributes k zápisu spolu
 *   s načtením košíku (jeden request navíc se tím ušetří)
 * @returns {Promise<any>}
 */
async function addGift(variantId, attributes) {
  const added = await post(
    ADD_URL,
    { items: [{ id: Number(variantId), quantity: 1, properties: { [GIFT_PROP]: GIFT_PROP_VALUE } } ] },
    { sections: false }
  );
  if (!added || added.status) return added;
  return post(UPDATE_URL, attributes ? { attributes } : {});
}

/**
 * Promítne odpověď do stránky — stejný event jako běžná změna košíku, takže se
 * zmorfuje drawer i /cart a přepočítá se badge.
 * @param {HTMLElement} source
 * @param {any} result
 */
function commit(source, result) {
  // `/cart/*.js` při chybě vrací `{ status, message }` místo košíku — z toho se
  // nemorphuje; lišta zůstane ve stávajícím stavu a srovná ji další render.
  if (!result || result.status) return;
  source.dispatchEvent(
    new CartUpdateEvent({}, 'tk-gift', {
      source: 'tk-gift',
      itemCount: result?.item_count,
      sections: result?.sections,
    })
  );
}

/**
 * Oslava odemčení dárku.
 *
 * ⚠️ Lišta se po KAŽDÉ změně košíku přerenderuje a zmorfuje, takže „právě teď
 * se to odemklo" nejde poznat z DOMu — musí se pamatovat předchozí stav.
 * `sessionStorage` proto, že přechod má přežít i navigaci (zákazník přidá
 * kvalifikující produkt na PDP a na /cart dorazí až dalším requestem).
 *
 * ⚠️ Instancí `<tk-gift>` je na stránce VÍC (lišta na /cart + lišta v draweru
 * v hlavičce). První, která přechod uvidí, přepíše uložený stav — ostatní by
 * pak neanimovaly. Proto krátké společné okno `celebrateUntil`.
 */
const UNLOCK_KEY = 'tk-gift-unlocked';
/** Musí pokrýt nejdelší animaci v `tk-gift-bar.liquid` (dech 2,8 s) + rezervu. */
const CELEBRATE_MS = 3200;
let celebrateUntil = 0;

/**
 * @param {boolean} unlocked
 * @returns {boolean} má se přehrát oslava
 */
function shouldCelebrate(unlocked) {
  let prev = null;
  try {
    prev = sessionStorage.getItem(UNLOCK_KEY);
  } catch {
    /* private mode — oslava se prostě nepřehraje */
  }

  const now = unlocked ? '1' : '0';
  if (prev !== now) {
    try {
      sessionStorage.setItem(UNLOCK_KEY, now);
    } catch {
      /* nevadí */
    }
  }

  // `prev === null` = první návštěva. Odemčený košík z minulé session není
  // důvod k oslavě, jen se stav zapamatuje.
  if (unlocked && prev === '0') {
    celebrateUntil = Date.now() + 1200;
    return true;
  }

  return unlocked && Date.now() < celebrateUntil;
}

class TkGift extends HTMLElement {
  connectedCallback() {
    // Auto-akce až po dokreslení, ať se nervou s probíhajícím morphem.
    requestAnimationFrame(() => {
      this.#reconcile();
      this.#maybeCelebrate();
    });
  }

  /**
   * Veřejný vstup pro modulový listener na `CartUpdateEvent` — po morphu
   * `connectedCallback` neběží, takže tohle je JEDINÁ cesta, jak se smír pustí
   * po změně košíku bez reloadu.
   */
  reconcileNow() {
    this.#reconcile();
    this.#maybeCelebrate();
  }

  /**
   * Veřejné odmítnutí — volá ho delegovaný listener dole. Tlačítko „Nechci
   * dárek" sedí na dárkovém ŘÁDKU košíku, tedy MIMO tenhle element, takže si
   * ho instance nemůže odchytit sama.
   */
  declineNow() {
    this.#decline();
  }

  /** Veřejné „přece jen ho chci" — tlačítko v liště po odmítnutí. */
  acceptNow() {
    this.#accept();
  }

  get #variantId() {
    return this.dataset.variantId || '';
  }

  get #unlocked() {
    return this.dataset.unlocked === '1';
  }

  get #inCart() {
    return this.dataset.inCart === '1';
  }

  /** @returns {number} kolik kusů dárku je v košíku (0 když žádný) */
  get #giftQty() {
    return Number(this.dataset.giftQty || 0);
  }

  /**
   * Srovná skutečný stav košíku s nárokem. Liquid už rozhodl, co platí — tady
   * se jen dorovnává rozdíl.
   */
  #reconcile() {
    if (busy || !this.#variantId) return;

    // Změna slevových kódů = nová šance. Bez tohohle by zákazník, který
    // blokující kód ODEBRAL, zůstal bez dárku až do poklesu pod práh:
    // `chargedGiftSeen` drží po celou dobu trvání nároku.
    const codes = this.dataset.codes || '';
    if (codes !== lastCodes) {
      lastCodes = codes;
      chargedGiftSeen = false;
    }

    // Lišta musí říct pravdu: nárok je, ale kód dárek vytlačil. Třída se
    // nastavuje při KAŽDÉM průchodu — morph ji z `class` atributu smaže.
    this.classList.toggle(
      'tk-gift--blocked',
      chargedGiftSeen && this.#unlocked && !this.#inCart
    );

    // ⚠️ Sleva na dárek nesedla a účtuje se → okamžitě pryč, ať ho zákazník
    // nezaplatí.
    if (this.dataset.notFree === '1') {
      // 🔴 Auto-add se zamkne JEN když nárok TRVÁ. Jen tehdy totiž hrozí
      // smyčka add ↔ remove (slevový kód bez `combinesWith.productDiscounts`).
      // Účtovaný dárek POD PRAHEM je naopak úplně normální stav — Shopify tam
      // slevu neuplatňuje — a zamykat kvůli němu je nejen zbytečné, ale škodí:
      // zámek přežil vyprázdnění košíku a dárek se pak nepřidal ani při novém
      // nákupu (nahlášeno 2026-09-04, viz `scheduleReconcile`).
      if (this.#unlocked) chargedGiftSeen = true;
      this.#remove();
      return;
    }

    // Nárok zanikl → nový nárok bude nová šance.
    if (!this.#unlocked) resetAddGuards();

    // Košík spadl pod práh, ale dárek v něm zůstal → odebrat.
    // (Platí i pro dárek přidaný ručně z URL produktu bez nároku.)
    if (!this.#unlocked && this.#inCart) {
      this.#remove();
      return;
    }

    // 🔴 Odmítnutí platí jen pro AKTUÁLNÍ nárok (2026-08-31). Když nárok
    // zanikne (košík pod prahem), zapamatované „Nechci dárek" se smaže —
    // příští překročení prahu je nová šance. Bez tohohle by po jediném
    // odmítnutí dárek už NIKDY nepřišel: atribut přežije pokles pod práh
    // i vyprázdnění košíku (`clear.js` maže jen položky, attributes
    // zůstávají), takže i úplně nový nákup v témže prohlížeči byl bez dárku
    // (nahlášeno uživatelem 2026-08-31). Zůstává: odmítnutí BĚHEM trvajícího
    // nároku se respektuje — dokud je košík nad prahem, dárek se nevrací
    // (leda tlačítkem „Chci dárek" v liště).
    if (!this.#unlocked && this.dataset.declined === '1') {
      this.#clearDecline();
      return;
    }

    // ⚠️ Víc než jeden kus zdarma. Selektor množství se u dárku nevykresluje,
    // ale `/cart/change.js` jde poslat ručně — tohle je poslední pojistka.
    if (this.#inCart && this.#giftQty > 1) {
      this.#capQuantity();
      return;
    }

    // Dárek je v košíku a je v pořádku (účtovaný by se vrátil o pár řádků výš)
    // → nárok je vyřízený, pojistky se můžou nulovat. Nuluje se i cooldown,
    // aby po odebrání a rychlém opětovném vzniku nároku nebylo nutné čekat.
    if (this.#inCart) {
      resetAddGuards();
      return;
    }

    // 🔴 AUTO-ADD. Nárok je, dárek chybí a zákazník ho neodmítl → přidat.
    // Odmítnutí (`data-declined`) drží jen po dobu trvání nároku; jakmile
    // košík spadne pod práh, atribut se maže výš v `#clearDecline()`.
    if (
      this.#unlocked &&
      this.dataset.declined !== '1' &&
      !chargedGiftSeen &&
      Date.now() >= declineGuardUntil
    ) {
      this.#add();
    }
  }

  /**
   * Přehraje oslavu odemčení: pop lišty, lime záře, přejezd lesku a výbuch
   * konfet z náhledu dárku.
   *
   * ⚠️ Konfety žijí v absolutně pozicované vrstvě UVNITŘ lišty (`overflow:
   * hidden`). Nesmí přetéct — lišta v draweru sedí ve scrollovacím kontejneru
   * a přetečené částice by mu udělaly scrollbar.
   */
  #maybeCelebrate() {
    if (!shouldCelebrate(this.#unlocked)) return;
    this.#playWhenVisible();
  }

  /**
   * Oslavu spustí, AŽ je lišta doopravdy vidět.
   *
   * ⚠️ Lišta v cart draweru existuje v DOMu i se zavřeným drawerem. Bez tohohle
   * čekání animace proběhla do prázdna dřív, než drawer vyjel, a zákazník
   * neviděl nic (uživatel 2026-08-29). Čeká se nejvýš 4 s — když se drawer
   * neotevře, oslava se prostě zahodí.
   */
  #playWhenVisible(attempt = 0) {
    const visible = this.isConnected && this.getClientRects().length > 0;

    if (!visible) {
      if (attempt > 20) return;
      window.setTimeout(() => this.#playWhenVisible(attempt + 1), 200);
      return;
    }

    this.#play();
  }

  #play() {
    // 🔴 ⚠️ ZÁMEK MUSÍ BÝT V MODULU, NE V `data-` ATRIBUTU. Zkoušel jsem
    // `data-celebrating` na elementu — jenže morph elementu přepíše atributy
    // podle serverového HTML, kde příznak není, takže se zámek ztratil a
    // oslava jela podruhé (nahlášeno 2026-08-29: „furt dvojitá").
    //
    // ⚠️ A musí být až TADY, ne v `#maybeCelebrate()`. Instancí `<tk-gift>` je
    // víc (lišta na /cart + lišta draweru v hlavičce) a ta neviditelná je
    // v DOMu první — kdyby zámek brala ona, viditelná by se k oslavě nedostala.
    // `#play()` běží jen u viditelné lišty, takže zámek bere ta správná.
    if (Date.now() - lastCelebrationAt < CELEBRATE_MS) return;
    lastCelebrationAt = Date.now();

    this.classList.add('tk-perk--celebrate');

    // 🔴 ⚠️ TŘÍDA MUSÍ PŘEŽÍT MORPH. Auto-add dárku zmorfuje lištu ~0,5 s po
    // startu oslavy a morph přepíše `class` podle serverového HTML, kde
    // `--celebrate` není → animace SEKLA V PŮLCE (nahlášeno 2026-08-29:
    // „sekané"). Observer třídu vrátí v mikrotasku, tedy JEŠTĚ PŘED přepočtem
    // stylů — prohlížeč její odebrání vůbec „neuvidí", takže běžící CSS
    // animace pokračují bez restartu (žádná druhá oslava).
    // Guard na `unlocked`: kdyby košík mezitím spadl pod práh, oslavu
    // na zamčené liště neudržujeme.
    const observer = new MutationObserver(() => {
      if (this.dataset.unlocked === '1' && !this.classList.contains('tk-perk--celebrate')) {
        this.classList.add('tk-perk--celebrate');
      }
    });
    observer.observe(this, { attributes: true, attributeFilter: ['class'] });

    window.setTimeout(() => {
      observer.disconnect();
      this.classList.remove('tk-perk--celebrate');
    }, CELEBRATE_MS);
  }

  /** Srovná množství dárku zpět na 1 kus. */
  async #capQuantity() {
    const lineKey = this.dataset.lineKey;
    if (!lineKey) return;

    const lock = this.#lock();
    if (!lock) return;

    try {
      commit(this, await post(CHANGE_URL, { id: lineKey, quantity: 1 }));
    } catch {
      // Ticho — při dalším renderu se pokus zopakuje.
    } finally {
      this.#unlock();
    }
  }

  async #remove() {
    const lineKey = this.dataset.lineKey;
    if (!lineKey || removedKeys.has(lineKey)) return;

    const lock = this.#lock();
    if (!lock) return;
    removedKeys.add(lineKey);

    try {
      commit(this, await post(CHANGE_URL, { id: lineKey, quantity: 0 }));
    } catch {
      // Ticho — při dalším renderu se pokus zopakuje.
    } finally {
      this.#unlock();
    }
  }

  /**
   * „Přece jen ho chci" po odmítnutí — jedním requestem zrušit příznak
   * a přidat. Bez tohohle tlačítka je odmítnutí až do poklesu pod práh
   * nevratné: auto-add se `data-declined` řídí a sám by dárek nevrátil.
   *
   * ⚠️ JEDNÍM requestem. Dva po sobě (update attributes → add) se rozjely:
   * morph z prvního překreslil lištu se starým „odmítnuto" a tlačítko
   * vypadalo, že nic nedělá.
   */
  async #accept() {
    const lock = this.#lock();
    if (!lock) return;

    // Zákazník si to rozmyslel — zámek po odmítnutí i všechny pojistky
    // auto-addu pryč, ať to dál funguje normálně.
    declineGuardUntil = 0;
    resetAddGuards();

    try {
      // add.js s property, pak jedním update.js zrušit příznak a načíst košík
      // (viz `addGift`) — morphuje se jen konečný stav, takže se lišta
      // nepřekreslí mezitím se starým „odmítnuto".
      const result = await addGift(this.#variantId, { [DECLINED_ATTR]: '' });
      if (!result?.status) removedKeys.clear();
      commit(this, result);
    } catch {
      // Ticho — lišta zůstane ve stávajícím stavu.
    } finally {
      this.#unlock();
    }
  }

  /** Smaže zapamatované odmítnutí — nárok zanikl, příští nárok je nová otázka. */
  async #clearDecline() {
    const lock = this.#lock();
    if (!lock) return;

    try {
      commit(this, await post(UPDATE_URL, { attributes: { [DECLINED_ATTR]: '' } }));
    } catch {
      // Ticho — při dalším renderu se pokus zopakuje.
    } finally {
      this.#unlock();
    }
  }

  /**
   * Odmítnutí: jedním requestem odeber dárek i zapamatuj rozhodnutí.
   *
   * 🔴 `declineGuardUntil` je nutnost, ne opatrnost. Smír čte stav až 260 ms po
   * `cart:update` a když se morph opozdí, přečte JEŠTĚ STARÉ atributy
   * (`declined=0`, `in-cart=0`) — a auto-add by dárek okamžitě vrátil zpátky,
   * takže by tlačítko „Nechci dárek" navenek nedělalo nic.
   */
  async #decline() {
    const lock = this.#lock();
    if (!lock) return;

    declineGuardUntil = Date.now() + 6000;

    // ⚠️ Odebírá se KLÍČ dárkového řádku, ne varianta — `updates` podle
    // variant ID by smazalo i placený nákup téhož produktu. Bez klíče
    // (dárek v košíku není) se jen zapíše odmítnutí.
    const lineKey = this.dataset.lineKey;
    const body = { attributes: { [DECLINED_ATTR]: 'ano' } };
    if (lineKey) body.updates = { [lineKey]: 0 };

    try {
      commit(this, await post(UPDATE_URL, body));
    } catch {
      // Ticho — lišta zůstane ve stávajícím stavu.
    } finally {
      this.#unlock();
    }
  }

  /**
   * Automatické přidání dárku po vzniku nároku.
   *
   * Přes `/cart/add.js` s property `_darek: ano` (viz `addGift`) — jediný
   * endpoint, který properties umí; `update.js` `updates` je neumí, takže by
   * vyrobil obyčejný placený řádek. Celý košík se pak načte druhým requestem.
   *
   * Tři pojistky proti smyčce, viz hlavička souboru: cooldown, strop pokusů
   * a `chargedGiftSeen` (hlídá se v `#reconcile`).
   */
  async #add() {
    const variantId = this.#variantId;
    if (!variantId) return;
    if (addAttempts >= 3) return;
    if (Date.now() - lastAddAt < ADD_COOLDOWN) return;

    const lock = this.#lock();
    if (!lock) return;

    lastAddAt = Date.now();
    addAttempts += 1;

    try {
      const result = await addGift(variantId);
      // Znovupřidaný dárek může dostat týž klíč řádku jako dřív odebraný —
      // bez tohohle by ho `removedKeys` blokoval před dalším odebráním.
      if (!result?.status) removedKeys.clear();
      commit(this, result);
    } catch {
      // Ticho — další pokus přijde s dalším renderem, strop pokusů to jistí.
    } finally {
      this.#unlock();
    }
  }

  /** @returns {boolean} true když se zámek povedlo získat */
  #lock() {
    if (busy) return false;
    busy = true;
    this.dataset.busy = '1';
    return true;
  }

  #unlock() {
    busy = false;
    delete this.dataset.busy;
  }
}

if (!customElements.get('tk-gift')) {
  customElements.define('tk-gift', TkGift);
}
/**
 * Delegované „Nechci dárek".
 *
 * 🔴 Tlačítko sedí na dárkovém ŘÁDKU košíku (`snippets/cart-products.liquid`),
 * tedy MIMO `<tk-gift>` — instance si klik odchytit nemůže. Listener na
 * dokumentu je navíc imunní vůči morphu: řádek se při každé změně košíku
 * překresluje a posluchač navěšený na tlačítku by se ztratil.
 */
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const decline = target.closest('[data-tk-gift-decline]');
  const accept = decline ? null : target.closest('[data-tk-gift-accept]');
  if (!decline && !accept) return;

  event.preventDefault();

  // Instancí `<tk-gift>` je na stránce víc (lišta na /cart + lišta draweru
  // v hlavičce), všechny ale nesou tutéž variantu — rozhodnutí je stav košíku,
  // ne konkrétního prvku, takže je jedno, která ho odbaví.
  const host = document.querySelector('tk-gift');
  if (!(host instanceof HTMLElement)) return;

  if (decline && typeof host.declineNow === 'function') host.declineNow();
  if (accept && typeof host.acceptNow === 'function') host.acceptNow();
});

/**
 * 🔴 JÁDRO OPRAVY (2026-08-29). `morph.js` lišty PATCHUJE NA MÍSTĚ, takže
 * `connectedCallback` proběhne jen při načtení stránky. Bez tohohle listeneru
 * zůstal dárek v košíku po propadnutí pod práh a Shopify ho naúčtoval plnou
 * cenou (zákazník ho přitom ve výpisu košíku ani neviděl) — a od návratu
 * auto-addu (2026-09-04) by se ani nepřidával po překročení prahu bez reloadu.
 *
 * ⚠️ Odloženo o `RECONCILE_PASSES` — v okamžiku eventu morph teprve běží a
 * atributy na elementech jsou STARÉ. Číst se musí až po překreslení.
 */
document.addEventListener('cart:update', () => {
  scheduleReconcile();
});

/**
 * 🔴🔴🔴 SLEVOVÝ KÓD NEDĚLÁ `cart:update`, ALE `discount:update`.
 *
 * `cart-discount.js` po uplatnění i odebrání kódu pošle `DiscountUpdateEvent`
 * a sekci jen zmorfuje. Bez tohohle listeneru se smír po zadání kódu VŮBEC
 * nespustí: morph sice přepíše `data-not-free` na 1, ale nikdo to nepřečte —
 * účtovaný dárek zůstane v košíku a zákazník ho ZAPLATÍ (nahlášeno 2026-09-04,
 * naměřeno 143,20 Kč za dárek po zadání kódu Review01). `connectedCallback` to
 * nezachrání, protože morph element nevyměňuje, jen mu přepíše atributy.
 */
document.addEventListener('discount:update', () => {
  scheduleReconcile();
});
